// Global
import { useTranslation } from 'react-i18next';

// Models
import { DocumentFillingStatus, ISelfDeclaration } from '@/models/documents.model';

// Components
import { Button } from '@/ui';
import {
  StyledButton,
  StyledButtonsWrap,
  StyledCardDescription,
  StyledCardTitle,
  StyledWrapper,
} from './SelfDeclarationBlockStyles';
import { DocumentIcon, EyeIcon } from '@/icons';

// Modules
import { useIsMobile } from '@/modules/Adaptive';

// Helpers
import getLocalSelfDeclarationStatus from '../../helpers/getLocalSelfDeclarationStatus';

type TSelfDeclarationBlock = {
  selfDeclaration?: ISelfDeclaration | null;
};

const SelfDeclarationBlock = ({ selfDeclaration }: TSelfDeclarationBlock) => {
  const { t } = useTranslation('documents');
  const { isMobile } = useIsMobile();
  const openCurrent = () => window.open(selfDeclaration?.file_link, '_blank');
  const selfDeclarationStatus = getLocalSelfDeclarationStatus(selfDeclaration);

  switch (selfDeclarationStatus) {
    case DocumentFillingStatus.EXPIRED:
      return (
        <StyledWrapper $status={DocumentFillingStatus.EXPIRED}>
          <StyledCardDescription>
            <StyledCardTitle>{t('documents_self_declaration_expired_title')}</StyledCardTitle>
          </StyledCardDescription>
          <StyledButtonsWrap>
            <Button size="large" shape="round" block onClick={openCurrent}>
              {t('documents_self_declaration_see_expired')}
            </Button>
          </StyledButtonsWrap>
        </StyledWrapper>
      );

    case DocumentFillingStatus.FILLED:
      return (
        <StyledWrapper $status={DocumentFillingStatus.FILLED}>
          <StyledCardDescription>
            <StyledCardTitle>{t('documents_self_declaration_filled_title')}</StyledCardTitle>
          </StyledCardDescription>
          <StyledButtonsWrap>
            <StyledButton
              type="primary"
              size="large"
              shape="round"
              block
              iconPosition="end"
              onClick={openCurrent}
              icon={<EyeIcon />}
            >
              {t('documents_self_declaration_view')}
            </StyledButton>
          </StyledButtonsWrap>
        </StyledWrapper>
      );

    case DocumentFillingStatus.UNFILLED:
    default:
      return (
        <StyledWrapper $status={DocumentFillingStatus.UNFILLED}>
          <StyledCardDescription>
            <StyledCardTitle>{t('documents_self_declaration_unfilled_title')}</StyledCardTitle>
          </StyledCardDescription>
          <StyledButtonsWrap>
            <Button type="primary" size="large" shape="round" block iconPosition="end" icon={<DocumentIcon />}>
              {t(isMobile ? 'documents_self_declaration_fill_in' : 'documents_self_declaration_fill_in_full')}
            </Button>
          </StyledButtonsWrap>
        </StyledWrapper>
      );
  }
};

export default SelfDeclarationBlock;
